// Liste des thèmes
export const themes = [
  'Divers',
  'Littérature et Langues',
  'Art',
  'Histoire',
  'Sport',
  'Culture Pop',
  'Science et Nature',
  'Géographie',
];


export const MAX_CARDS_PER_SESSION = 20;

// Configurations des tuiles (couleurs et sous-thèmess)
export const tileConfigs = {
  "Littérature et Langues": { color: '#9b59b6', subThemes: ['Littérature', 'Prix Goncourt'] },
  "Art": { color: '#4B0082', subThemes: ['Architecture', 'Sculpture', 'Peinture'] },
  "Géographie": { color: '#3498db', subThemes: ['Capitale', 'Drapeau', 'Monnaies'] },
  "Science et Nature": { color: '#2ecc71', subThemes: ['Nature', 'Astronomie', 'Prix Nobel', 'Médaille Fields', 'Prix Turing', 'Animaux'] },
  "Culture Pop": { color: '#f1c40f', subThemes: ['Cinéma', 'Musique', 'Fort Boyard'] }, 
  "Sport": { color: '#e67e22', subThemes: ['Football', 'Formule 1'] }, 
  "Histoire": { color: '#e74c3c', subThemes: [] },
  "Divers": { color: '#C0C0C0', subThemes: [] }
};

// Positionnement des cercles pour 8 thèmes
const radius = 261;
export const circlePositions = themes.map((_, index) => {
  if (index === 0) return { x: 0, y: 0 }; // "Divers" au centre
  const angle = ((index - 1) * 2 * Math.PI) / (themes.length - 1); // Répartir les 7 autres thèmes autour
  return { x: radius * Math.cos(angle), y: radius * Math.sin(angle) };
});

// Positionnement des sous-thèmes
export const subThemePositions = [
  { x: 140, y: 0 }, // 1er cercle au centre
  { x: 100, y: -78 }, //2e cercle au dessus
  { x: -100, y: -78 }, //3e cercle au dessus
  { x: -140, y: 0 }, //4e cercle a centre gauche
  { x: -122, y: 77 }, //5e cercle en bas à gauche
  { x: 122, y: 77 },
];